import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Thickness extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Thickness'
  // Define default properties here
    static instanceDefaults() {
    return {
        psid: '',
        thickness: '',
    }
  }
}
const servicePath = 'thicknesses'
const servicePlugin = makeServicePlugin({
    Model: Thickness,
    service: feathersClient.service(servicePath),
    servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
